export default __webpack_public_path__ + "static/media/10007.50aab5a2.png";